import React from 'react'
import { Col, Dropdown, Row } from 'antd'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { InfoItem } from 'Pages/Merchants/components'
import { TaxData } from 'Store/tax-management/types'
import ReactToPrint from 'react-to-print'
import { PrimaryButton } from 'Components/button'
import { PrinterOutlined } from '@ant-design/icons'
import { formatDateTime, getMenuTypeName } from 'helpers/format'
import { menuTaxtatus, Taxtatus } from 'helpers/constanst'
import { StatusTag } from 'Components/utilities'
import { ConfigData } from 'Store/pos/types'
import { MenuPrints } from 'Components/form'

type Props = {
  detail?: TaxData
  printPDF?: any
  onSelectTitle: (title: string) => void
  configData?: ConfigData
}

const TaxInfo: React.FunctionComponent<Props> = props => {
  const { detail, printPDF, onSelectTitle, configData } = props
  const config = configData && configData?.config_value && JSON.parse(configData?.config_value || '')

  const renderInfo = (title: string, value: any, span: number = 15) => {
    return <InfoItem title={title} value={value} span={span} />
  }

  const renderTaxStatus = (status: string) => (
    <StatusTag isPass={status === Taxtatus.SUCCESS} text={getMenuTypeName(menuTaxtatus, status)} />
  )

  return (
    <BoxWrapper>
      <Row justify="space-between">
        <Col>
          <BoxTitle>ข้อมูลใบกำกับภาษี</BoxTitle>
        </Col>
        <Col>
          {/* <ReactToPrint
            trigger={() => {
              return (
                <PrimaryButton
                  key={`print`}
                  icon={<PrinterOutlined />}
                  text="พิมพ์ใบกำกับภาษี"
                  btnType="Primary"
                  onClick={() => { }}
                  size="middle"
                />
              )
            }}
            content={() => printPDF.current}
            documentTitle={`ใบกำกับภาษี-${detail?.tax_invoice_no}`}
            titleSelection={config?.header || null}
            onSelectTitle={onSelectTitle}
          /> */}
          <Dropdown
            key="more"
            overlay={
              <MenuPrints
                nomalPrintRef={printPDF}
                title={`ใบกำกับภาษี-${detail?.tax_invoice_no}`}
                titleSelection={config?.header || null}
                onSelectTitle={onSelectTitle}
              />
            }
            trigger={['click', 'hover']}
          >
            <PrimaryButton
              btnType="Primary"
              text="พิมพ์ใบกำกับภาษี"
              icon={<PrinterOutlined />}
              onClick={() => {}}
              size="middle"
            />
          </Dropdown>
        </Col>
      </Row>
      <Row>
        <Col md={12} xs={24}>
          {renderInfo('เลขที่ใบกำกับภาษี', detail?.tax_invoice_no)}
          {renderInfo('วันที่ออกใบกำกับภาษี', formatDateTime(detail?.created_at || ''))}
        </Col>
        <Col md={12} xs={24}>
          {renderInfo('สถานะใบกำกับภาษี', renderTaxStatus(detail?.status || ''))}
          {detail?.status === Taxtatus.CANCEL &&
            renderInfo('วันที่ยกเลิก', formatDateTime(detail?.updated_at || ''))}
          {detail?.status === Taxtatus.CANCEL &&
            renderInfo('เหตุผลการยกเลิก', <Reason>{detail?.reason || ''}</Reason>)}
        </Col>
      </Row>
    </BoxWrapper>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const Reason = styled.span`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
`

export default TaxInfo
